import React, { useEffect, useState } from "react";
import { Page, Text, View, Document, StyleSheet, Image, Font } from "@react-pdf/renderer";
import QRCode from "qrcode";
import { OrderType } from "../../../interfaces/delivery-company/orders";
import { get_cod } from "../../../utils/cod";
import { displayMoney, isNonZero } from "../../../utils/money";
import { format } from "date-fns";
import { displayLocation } from "../../../utils/locations";
import { IDeliveryBatch } from "../../../interfaces/delivery-company/tasks";
import { Workflow } from "../../../enums/orders";
import { encodePermanentPackage } from "../../../utils/encoding";
import { IMerchantOrdersInvoice } from "../../../interfaces/common/merchant-invoices";
import { merchantInvoiceTaskToQRcodeID } from "../../../utils/merchant-invoices";
import { ShopLocationType } from "../../../interfaces/delivery-company/pickups";
import { registerFonts } from "../../../utils/pdf-fonts";

registerFonts();

const styles = StyleSheet.create({
    page: { padding: 25, fontSize: 12, fontFamily: 'Noto Sans Arabic', backgroundColor: "#fff" },
    section: { marginBottom: 5, padding: 20, backgroundColor: "#fff", borderRadius: 10, boxShadow: "0px 4px 8px rgba(0,0,0,0.15)" },
    header: { fontSize: 13, fontWeight: "bold", marginBottom: 10, textAlign: "center", color: "#222", textTransform: "uppercase", borderBottomWidth: 3, borderBottomColor: "#333", paddingBottom: 10, letterSpacing: 1 },
    pageHeader: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 5,
    },
    logo: {
        height: 55,
    },
    contactInfo: { fontSize: 12, marginBottom: 8, color: "#444" },
    table: { display: "flex", flexDirection: "column", borderWidth: 1, borderColor: "#aaa", borderRadius: 6, overflow: "hidden", backgroundColor: "#fafafa" },
    row: { flexDirection: "row", borderBottomWidth: 1, borderBottomColor: "#ccc", backgroundColor: "#fff" },
    cell: { flex: 1, padding: 12, fontSize: 12, textAlign: "center", color: "#333" },
    qrCell: { flex: 1, padding: 12, alignItems: "center", justifyContent: "center" },
    section_title: { color: "#000", margin: "auto", marginBottom: 5, fontSize: 14 },
    footer: { marginTop: 10, textAlign: "center", fontSize: 12, color: "#555", borderTopWidth: 1, borderTopColor: "#bbb", paddingTop: 12 },
});

const generateQRCode = async (text: string) => {
    try {
        return await QRCode.toDataURL(text);
    } catch (err) {
        console.error(err);
        return "";
    }
};

interface WaybillProps {
    merchantInvoice: IMerchantOrdersInvoice;
    paymentLocation: ShopLocationType | null;
    orgId: string;
}



const OnePager = ({ merchantInvoice, orgId, paymentLocation }: WaybillProps) => {
    const [qrCode, setQRCode] = useState("");

    useEffect(() => {
        generateQRCode(merchantInvoiceTaskToQRcodeID(merchantInvoice)).then(setQRCode);
    }, [merchantInvoice.id]);


    return (
        <Page size="A4" style={styles.page} wrap={false}>
            <View style={styles.pageHeader}>

                <Image
                    style={styles.logo}
                    src={`https://parcel-tracer-public.s3.eu-central-1.amazonaws.com/${orgId}/logo.png?v=${new Date().getTime()}`}
                />

                <View style={styles.qrCell}>
                    {qrCode && <Image style={{ width: 90, height: 90 }} src={qrCode} />}
                </View>
            </View>

            <View style={styles.section}>
                <View style={styles.table}>
                    <View style={[styles.row, { backgroundColor: "#e2e6ea" }]}>
                        <Text style={[styles.cell,]}>Payment Reference</Text>
                        <Text style={[styles.cell,]}>Payment To</Text>
                        {paymentLocation?.area &&  <Text style={[styles.cell,]}>At</Text>}
                        <Text style={[styles.cell,]}>Net Amount</Text>
                    </View>

                    <View style={styles.row}>
                        <Text style={styles.cell}>
                            <Text>Invoice #{merchantInvoice.id} {"\n\n"} {format(
                                new Date(merchantInvoice.created_at ?? ""),
                                'dd-MM-yyyy'
                            )}</Text>
                        </Text>
                        <Text style={styles.cell}><Text>{merchantInvoice.merchant?.name} {"\n\n"} {merchantInvoice.merchant?.phone_number} </Text></Text>
                        {paymentLocation?.area  && <Text style={styles.cell}><Text> {paymentLocation.area.district} {"\n\n"} {paymentLocation.area.name_en} | {paymentLocation.area.name_ar}</Text></Text>}
                        <Text style={styles.cell}>  <Text>{displayMoney(merchantInvoice.net_due_to_merchant)} </Text></Text>
                    </View>
                </View>
            </View>

            <View style={styles.footer} wrap={false}>
                <Text>Thank you for choosing our services.</Text>
            </View>
        </Page>)

}

const InvoiceWaybill = ({ merchantInvoice, paymentLocation, orgId }: WaybillProps) => {

    return (
        <Document>
            <OnePager merchantInvoice={merchantInvoice} orgId={orgId} paymentLocation={paymentLocation} />
        </Document>
    );
};

export default InvoiceWaybill;
